import React from 'react';
import Grid from '@mui/material/Grid';
import icyteAnalyticsLogo from './assets/icyte-analytics.png'
import icyteGrossToNetLogo from './assets/icyte-gross-to-net.png'
import icytePaymentPortalLogo from './assets/icyte-payment-portal.png';
import distributionContractLogo from './assets/distribution-contract-manager.png';
import orderManagementLogo from './assets/order-management.png';
import shareFile from './assets/share-file.png'
import ContractAndPricing from './assets/icyte-contract-and-pricing.png';
import ContractAndPricingA from './assets/icyte-contract-and-pricing_analytics.png'
import { LINKS_CONFIG } from './LinksConfig';
import MenuItem from './MenuItem';
import './App.css';


const MANUFACTURERS_OM = ["merck", "valeant", "demo", "demo2", "genentech"]

export default function App() {

  const queryParams = new URLSearchParams(window.location.search);

  let itemsDisabled = queryParams.get("itemsDisabled") || "";
  itemsDisabled = itemsDisabled.split(",");

  let env = queryParams.get("env") || "dev";
  if (LINKS_CONFIG[env] === undefined) {
    env = "dev"
  }

  let manufacturer = queryParams.get("manufacturer") || undefined;
  let extraManufacurerParam = "";
  let extraManufacturerParamIcyteAnalytics = "";
  if (manufacturer) {
    extraManufacurerParam = `&m=${manufacturer}`;
    extraManufacturerParamIcyteAnalytics = `?mfg=${manufacturer}`;

    if (!MANUFACTURERS_OM.includes(manufacturer)) {
      itemsDisabled.push("5")
    }
  }

  return (
    <div className="container-app">
      <div className="title"> IntegriChain Apps</div>
      <Grid
        container
        spacing={3}
      >
        <Grid item xs={6} sm={4} md={3}>
          <MenuItem isDisabled={itemsDisabled.includes("1")}
            title="ICyte Analytics"
            imageClassName="image-icyte"
            logo={icyteAnalyticsLogo}
            link={LINKS_CONFIG[env]["icyte_analytics"] + extraManufacturerParamIcyteAnalytics} />
        </Grid>
        <Grid item xs={6} sm={4} md={3}>
          <MenuItem isDisabled={itemsDisabled.includes("2")}
            title="ICyte Gross-to-Net"
            imageClassName="image-gtn"
            logo={icyteGrossToNetLogo}
            link={LINKS_CONFIG[env]["icyte_gtn"]} />
        </Grid>
        <Grid item xs={6} sm={4} md={3}>
          <MenuItem isDisabled={itemsDisabled.includes("3")}
            title="ICyte Payment Portal"
            imageClassName="image-payment-portal"
            logo={icytePaymentPortalLogo}
            link={LINKS_CONFIG[env]["icyte_payment"]} />
        </Grid>
        <Grid item xs={6} sm={4} md={3}>
          <MenuItem isDisabled={itemsDisabled.includes("4")}
            title="Distribution Contract Management"
            imageClassName="image-distrubution-contract"
            logo={distributionContractLogo}
            link={LINKS_CONFIG[env]["icyte_dcm"] + extraManufacurerParam} />
        </Grid>
        <Grid item xs={6} sm={4} md={3}>
          <MenuItem isDisabled={itemsDisabled.includes("5")}
            title="Order Management"
            imageClassName="image-om"
            logo={orderManagementLogo}
            link={LINKS_CONFIG[env]["icyte_om"] + extraManufacurerParam} />
        </Grid>
        <Grid item xs={6} sm={4} md={3}>
          <MenuItem isDisabled={itemsDisabled.includes("6")}
            title="ShareFile"
            imageClassName="image-sharefile"
            logo={shareFile}
            link={LINKS_CONFIG[env]["share_file"]} />
        </Grid>
        <Grid item xs={6} sm={4} md={3}>
          <MenuItem isDisabled={itemsDisabled.includes("7")}
            title="ICyte Contracts and Pricing"
            imageClassName="image-contracts_p"
            logo={ContractAndPricing}
            link={LINKS_CONFIG[env]["contracts_and_pricing"]} />
        </Grid>
        <Grid item xs={6} sm={4} md={3}>
          <MenuItem isDisabled={itemsDisabled.includes("8")}
            title="ICyte Contracts and Pricing Analytics"
            imageClassName="image-contracts_p_a"
            logo={ContractAndPricingA}
            link={LINKS_CONFIG[env]["contracts_and_pricing_analytics"]} />
        </Grid>
      </Grid>
    </div>
  );
}
